import * as T from "../constants";

const initialState = {
    addressLine1: "",
    addressLine2:"",
    city: "",
    state: "",
    postalCode: ""
}

const mailingAddressReducer = (state = initialState, action) => {
    const { payload, type } = action;
    switch (type) {
        case T.MAILING_ADDRESS_REQUESTED:
            return {
                ...state,
                ...payload
            }
        default:
            return state;
    }
}

export default mailingAddressReducer;